




















































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";

import GerencialConsultaPagamentoService from "@/service/relatorio/gerencial/GerencialConsultaPagamentoService";
import { RelatorioConsultaPagamentoModel } from "@/models/administracao/consulta-pagamento/RelatorioConsultaPagamentoModel";
import { PaginationModel } from "@/models/commons/PaginationModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
  },
})
export default class RelatorioConsultaPagamento extends Vue {
  $refs!: {
    relatorioObserver: InstanceType<typeof ValidationObserver>;
  };

  listaPagamento = [];
  tableHeader = [
    { text: 'Data', value: 'dataPagamento', width: '15%' },
    { text: 'CPF / CNPJ', value: 'cpfCnpj', width: '15%' },
    { text: 'Prestador', value: 'prestador', width: '35%' },
    { text: 'Serviço', value: 'servico', width: '15%' },
    { text: 'NF', value: 'numeroNf', width: '15%' },
    { text: 'Tipo Pagamento', value: 'tipoPagamento', width: '35%' },
  ];
  tableOptions: PaginationModel = {
    itemsPerPage: 5,
    page: 1,
    itemsLength: 1,
  };

  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  loading = false;

  relatorio: RelatorioConsultaPagamentoModel = {
    inicio: undefined,
    fim: undefined,
  };

  public gerarRelatorio(tipo: string): void {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        GerencialConsultaPagamentoService.gerarRelatorio(tipo, this.relatorio)
          .then((res) => {
            console.log(res);
            let fileURL = window.URL.createObjectURL(new Blob([res.data]));
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;

            fileLink.setAttribute(
              "download",
              `relatorio_pagamento.${
                tipo.toLowerCase() === "excel" ? "xls" : "pdf"
              }`
            );

            document.body.appendChild(fileLink);

            fileLink.click();

            this.loading = false;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });

        // this.limparformulario();
      }
    });
  }

  getData() {
    this.loading = true;
    GerencialConsultaPagamentoService
      .consultar(this.relatorio, this.tableOptions)
      .then((res: any) => {
        this.listaPagamento = res;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public limparformulario(): void {
    this.relatorio = {};
    this.$refs.relatorioObserver.reset();
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }
}
